import React from 'react';
import { HashRouter, Routes, Route, Link, useLocation } from 'react-router-dom';
import { Home as HomeIcon, Info } from 'lucide-react';
import { motion } from 'framer-motion';
import LandingPage from './pages/LandingPage';
import HomePage from './pages/HomePage';
import VideoPage from './pages/VideoPage';
import BehindTheScenes from './pages/BehindTheScenes';

const Navigation: React.FC = () => {
  const location = useLocation();
  const isBts = location.pathname === '/bts';
  const isHome = location.pathname === '/' || location.pathname.startsWith('/video');

  return (
    <motion.nav 
      initial={{ y: -100, x: '-50%' }}
      animate={{ y: 0, x: '-50%' }}
      className="fixed top-6 left-1/2 z-50 flex items-center gap-1.5 px-3 py-1.5 bg-zinc-900/80 backdrop-blur-2xl border border-white/10 rounded-full shadow-2xl"
    >
      <Link 
        to="/" 
        className={`p-2.5 rounded-full transition-all duration-300 flex items-center justify-center ${isHome ? 'bg-white text-black shadow-lg shadow-white/10' : 'text-white/40 hover:text-white hover:bg-white/5'}`}
        aria-label="Home"
      >
        <HomeIcon size={18} />
      </Link>
      
      <div className="w-px h-4 bg-white/10 mx-0.5" />
      
      <Link 
        to="/bts" 
        className={`px-4 py-2 rounded-full transition-all duration-300 flex items-center gap-2 ${isBts ? 'bg-white text-black shadow-lg shadow-white/10 font-black' : 'text-white/40 hover:text-white hover:bg-white/5'}`}
      >
        <Info size={16} />
        <span className="text-[9px] uppercase tracking-widest font-black">Dev Log</span>
      </Link>
    </motion.nav>
  );
};

const App: React.FC = () => {
  return (
    <HashRouter>
      <div className="min-h-screen bg-black text-white selection:bg-green-500 selection:text-black font-montserrat relative">
        <div className="relative z-10">
          <Routes>
            <Route path="/landing" element={<LandingPage />} />
            <Route path="/" element={<HomePage />} />
            <Route path="/video/:personId" element={<VideoPage />} />
            <Route path="/bts" element={<BehindTheScenes />} />
          </Routes>
        </div>
        
        <Navigation />
      </div>
    </HashRouter>
  );
};

export default App;